import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { CancelVisit, ConfirmTheVisit, FooterHomeIcon } from "~misc/icons";
import { initialPath } from "~misc/paths";
import useFooter from "../hooks/useFooter";
import useModalAction from "~components/Modal/hooks/useModalAction";
import ModalResponse from "~components/Modal/ModalResponse";
import ModalAction from "~components/Modal/ModalAction";
import "../style.scss";
import useCheckIn from "~fetchs/Roterizacao/useCheckIn";

const DefaultFooter = ({ options, setOptions }) => {
  const { handleBack } = useFooter(options, setOptions);
  const currentPath = window.location.pathname;
  const isPesquisaDePrecoPath = /^\/pesquisa-de-preco\/\d+$/.test(currentPath);

  const {
    form,
    formId,
    submitButtonComponent,
    submitLabel,
    submitVariation,
    buttonsComponent,
    hideHomeButton,
    hideReturnButton,
    disabled,
    selectButton,
    labelBack,
    defaultBack,
  } = options;

  const {
    isModalOpenAction: isModalClear,
    closeModalAction: closeModalclear,
    openModalAction: openModalClear,
  } = useModalAction();

  const {
    isModalOpenAction: isModalClearResponse,
    closeModalAction: closeModalclearResponse,
    openModalAction: openModalClearResponse,
  } = useModalAction();

  const OpenclearCache = async () => {
    openModalClear();
  };

    const { parameter } = useParams();
    const { checkin } = useCheckIn();
     const navigate = useNavigate();




    const pathRegex = /^\/gestao-de-pesquisa\/formularios\/\d+$/;

    const shouldShowExtraButton =
  pathRegex.test(currentPath) &&
  Number(parameter) === checkin?.clienteId;


  const params = new URLSearchParams(globalThis.location.search);
  const origem = params.get("origem");


  return (
    <footer className={`footer  ${options?.notDeveloped ? "not-developed" : ""}`}>
      <div className="content container relative">
        {hideReturnButton && defaultBack && (
          <button
            onClick={handleBack}
            className="button back-button flex items-center gap-x-2 !bg-[#FF2E00] !text-white font-bold px-4 py-4 rounded-full  !border-none"
          >
            {labelBack}
            <CancelVisit />
          </button>
        )}
        {!hideReturnButton && !defaultBack && (
          <>
            <button onClick={handleBack} className="button back-button">
              Voltar
            </button>
             {shouldShowExtraButton && (
               <button onClick={() => navigate(`/roteirizacao/${checkin.clienteId}`)}  className="button back-button roteirizacao">
                Voltar visita
              </button>
             )}

              {origem === "carteira-geral" && !shouldShowExtraButton && (
               <button onClick={() => navigate(`/carteira`)}  className="button back-button carteira">
                carteira
              </button>
             )}
            {isPesquisaDePrecoPath && (
              <>
                <button
                  type="button"
                  className=" absolute left-[178px] bg-primaria text-white p-4 rounded-full z-50 shadow-lg hover:bg-[#9ACA3C] mr-4"
                  onClick={OpenclearCache}
                >
                  Limpar alterações
                </button>
              </>
            )}
          </>
        )}

        {!hideHomeButton && (
          <Link to={initialPath} className="home-button">
            <FooterHomeIcon className="icon" />
          </Link>
        )}

        {buttonsComponent}

        {form ? (
          <>
            {submitButtonComponent ?? (
              <>
                {submitVariation == "green" ? (
                  <button
                    key={currentPath}
                    type="submit"
                    form={formId}
                    className={`button send-button green  ${selectButton ?? ""} ${disabled ? "disabled" : ""}`}
                    id={formId}
                    disabled={disabled}
                    aria-disabled={disabled}
                  >
                    {submitLabel}

                    <span className="pl-2">
                      <ConfirmTheVisit />
                    </span>
                  </button>
                ) : (
                  <button
                    key={currentPath}
                    type="submit"
                    form={formId}
                    className={`button send-button  ${selectButton ?? ""}  ${disabled ? "disabled" : ""}`}
                    id={formId}
                    disabled={disabled}
                    aria-disabled={disabled}
                    data-test-id="button-submit-footer"
                  >
                    {submitLabel}
                  </button>
                )}
              </>
            )}
          </>
        ) : null}

        <ModalAction
          isOpen={isModalClear}
          onClose={closeModalclear}
          title={`Deseja limpar o cache do cliente?`}
          sub="A ação não pode ser revertida"
          buttonOne="Sim"
          buttonTwo="Não"
          linkOne={() => {
            options?.handleModalClear?.();
            closeModalclear();
          }}
          linkTwo={closeModalclear}
        />

        <ModalResponse
          isOpen={isModalClearResponse}
          closeModal={closeModalclearResponse}
          status={"success"}
          message={"Cache limpo com sucesso!"}
          submessage={""}
          button="Ok"
        />
      </div>
    </footer>
  );
};

export default DefaultFooter;
